module.exports = __webpack_public_path__ + "img/imagenpdf.ae4c72ad.png";